import { useMutation } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";

interface Document {
  type: string;
  blobUrl: string;
  [key: string]: any;
}

interface DocumentsResponse {
  data: Document[];
}

function useGetTermsAndConditions() {
  const { authState } = useOktaAuth();

  return useMutation({
    mutationKey: ["getTermsAndConditions"],
    mutationFn: (id?: string) => {
      const endpoint =
        id === "isAltheaDxNeuropsychotropicMedications"
          ? "v1/documents?type=idg-mapping"
          : "v1/documents";
      return axiosInstance.get<DocumentsResponse>(endpoint, {
        headers: {
          Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
        },
      });
    },
  });
}

export default useGetTermsAndConditions;
